import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { BackHeader } from '../../components/BackHeader';
import { Play, Pause, RotateCcw, CheckCircle } from 'lucide-react';

export const VideoPlayer: React.FC = () => {
  const { videoId } = useParams<{ videoId: string }>();
  const [isPlaying, setIsPlaying] = useState(false);
  const [progress] = useState(0);
  
  const video = {
    id: videoId,
    title: 'Power Tongs Setup',
    duration: '12:34',
    category: 'Equipment Training',
    completed: false,
  };

  return (
    <div className="min-h-full pb-[var(--bottom-chrome)] bg-fieldiq-dark">
      <BackHeader
        to="/training"
        label="Training"
        title={video.title}
        subtitle={video.category}
      />
      
      <main className="pb-20">
        <div className="aspect-video bg-black relative flex items-center justify-center">
          <button
            onClick={() => setIsPlaying(!isPlaying)}
            className="w-16 h-16 bg-fieldiq-accent rounded-full flex items-center justify-center hover:bg-amber-400 transition-colors"
          >
            {isPlaying ? (
              <Pause className="w-8 h-8 text-fieldiq-dark" />
            ) : (
              <Play className="w-8 h-8 text-fieldiq-dark ml-1" />
            )}
          </button>
          
          <div className="absolute bottom-0 left-0 right-0 h-1 bg-fieldiq-border">
            <div 
              className="h-full bg-fieldiq-accent-signal transition-all"
              style={{ width: `${progress}%` }}
            />
          </div>
        </div>

        <div className="max-w-[1920px] mx-auto px-4 py-4">
          <div className="flex items-center justify-between mb-4">
            <div>
              <h2 className="text-lg font-semibold text-white">{video.title}</h2>
              <p className="text-fieldiq-text text-sm">{video.duration}</p>
            </div>
            <button className="flex items-center gap-2 text-fieldiq-accent">
              <RotateCcw className="w-5 h-5" />
              <span className="text-sm">Restart</span>
            </button>
          </div>

          {!video.completed && (
            <button className="w-full bg-fieldiq-accent text-fieldiq-dark py-3 rounded-lg font-semibold flex items-center justify-center gap-2 hover:bg-amber-400 transition-colors">
              <CheckCircle className="w-5 h-5" />
              Mark as Complete
            </button>
          )}
        </div>
      </main>
    </div>
  );
};
